export default {
    FUSO_HORARIO_DEFAULT: 'America/Sao_Paulo'
}
